import { InfoCircleOutlined, InfoIcon } from "@/styles/icons"
import { InfoIconNotFilled } from "@/styles/icons/InfoIconNotFilled"
import { InfoIconOutlineBlue } from "@/styles/icons/InfoIconOutlineBlue"
import { Button, Modal } from "barte-design-system"
import { useState } from "react"

export function HelperToLoggin() {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <button
                type="button"
                style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
                onClick={() => setIsOpen(true)}
            >
                <span style={{ color: "#1890FF", fontSize: "14px", fontWeight: 400 }}>
                    Está com dificuldades para acessar?
                </span>
            </button>

            <Modal
                isOpen={isOpen}
                title="Está com dificuldades para acessar?"
                onClose={() => setIsOpen(false)}
                footer={{
                    primaryButton: {
                        children: "Ok",
                        onClick: () => setIsOpen(false),
                    },
                }}
            >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "16px" }}>
                    <InfoIconOutlineBlue size={24} />
                    <p style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}>
                        Caso você esteja com dificuldades para acessar ou tenha perdido acesso ao seu aplicativo de autenticação, por favor entre em contato com o nosso suporte por email ou telefone.
                    </p>
                </div>
            </Modal>
        </>
    )
}
